import { MODAL } from '../utils/constants.json';

/**
 * action -close modal and dispatch success actions.
 * @param {string} content context body of modal
 * @param {string} title title of modal
 * @param {string} type title of modal
 * @param {string} cBtn title of modal
 * @param {string} sBtn title of modal
 * @param {string} width title of modal
 * @param {string} contentType title of modal
 * @param {string} aType title of modal
 * @param {string} sbtnAction title of modal
 * @param {string} cbtnAction title of modal
 * @return {object}
 */
export function openViewDefaultModal(
  content: string,
  title: string,
  type: string,
  cBtn: string,
  sBtn: string,
  width: string,
  contentType: string,
  aType: string,
  sbtnAction: () => void,
  cbtnAction: () => void,
  isOutsideClickDisabled = false,
) {
  return {
    type: aType || MODAL.OPEN_DEFAULT_MODAL,
    payload: {
      content,
      title,
      type,
      cBtn,
      sBtn,
      width,
      contentType,
      aType,
      sbtnAction,
      cbtnAction,
      isOutsideClickDisabled,
    },
  };
}
/**
 * action -close modal and dispatch success actions.
 * @param {string} aType title of modal
 * @return {object}
 */
export function closeViewDefaultModal(aType: string) {
  return {
    type: aType || MODAL.CLOSE_DEFAULT_MODAL,
    payload: { content: '', title: '' },
  };
}
